import PageNotFoundPage from './PageNotFoundPage'

export default PageNotFoundPage
